export default class CreatePatientHistoryEntryReq {
    constructor() {
        this.Id = null;
        this.Notes = null;
        this.TimeStamp = null;
        this.PatientId = null;
        this.TherapistId = null;
        this.AccountingSessionId = null;
        this.SessionId = null;
        this.FileUrl = null;
        this.FilePath = null;
        this.FileType = null;
        this.FileName = null;
        this.pagingParams = {
            pageNumber: 1,
            pageSize: 100,
        }
    }
}